import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_URL } from '../models/api-url.token';
import { IApplySubscriptionPlanResultVm } from '../apply-subscription-plan-result-vm.model';
import { IApplySubscriptionPlanToCompanyIm } from '../apply-subscription-plan-to-company-im.model';
@Injectable({ providedIn: 'root' })
export class ApplySubscriptionPlanService {
  private readonly baseUrl: string;
  constructor(private http: HttpClient, @Inject(API_URL) private apiUrl: string) {
    this.baseUrl = `${this.apiUrl}/ApplySubscriptionPlan`;
  }
  post(applySubscriptionPlanToCompanyIm: IApplySubscriptionPlanToCompanyIm): Observable<IApplySubscriptionPlanResultVm> {
    const headers = this.createHeaders();
    return this.http.post<IApplySubscriptionPlanResultVm>(this.baseUrl, applySubscriptionPlanToCompanyIm, { headers });
  }
  delete(companyGuid: string): Observable<any> {
    const headers = this.createHeaders();
    let params = new HttpParams();
    if (companyGuid !== undefined && companyGuid !== null) {
      params = params.set('companyGuid', companyGuid.toString());
    }
    return this.http.delete<any>(this.baseUrl, { headers, params });
  }
  private createHeaders(): HttpHeaders {
    let headers = new HttpHeaders();
    const token = localStorage.getItem('authToken');
    if (token) headers = headers.set('Authorization', `Bearer ${token}`);
    return headers;
  }
}
